import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import {useWhiteLabelDm} from "../../../../../__snowpack__/link/packages/old-dm/dist/dm.esm.js";
import {useTranslation} from "../../../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {cmpClassName, execFn} from "../../../../common/generic-react.functions.js";
import {FormRowContainer, FormTitleRowContainer} from "../../../../common/generic-react.styles.js";
import Form from "../../../../components/atoms/form/form.component.js";
import Input from "../../../../components/atoms/input/input.component.js";
import SectionTitle from "../../../../components/atoms/section-title/section-title.component.js";
import Title from "../../../../components/atoms/title/title.component.js";
import CheckboxGroup from "../../../../components/molecules/checkbox-group/checkbox-group.component.js";
import Expander from "../../../../components/molecules/expander/expander.component.js";
import {withReduxAndStyle} from "../../../../hoc/bridge.hoc.js";
import {useAccountPermissionsItems, useAdminPermissionsItems} from "../../../../hooks/permissions-items.hooks.js";
import {useWhiteLabelItemGenerator} from "./white-label-detail.hooks.js";
import {WhiteLabelDetailFormContainer, WhiteLabelMainContainer} from "./white-label-detail.styles.js";
import Icon from "../../../../components/atoms/icon/icon.component.js";
import Modal from "../../../../components/atoms/modal/modal.component.js";
import WhiteLabelSkiningDetailPage from "./white-label-skining-detail.page.js";
import SwitchOnIcon from "../../../../assets/images/switch-on-icon.js";
import SwitchOffIcon from "../../../../assets/images/switch-off-icon.js";
function WhiteLabelDetailPage({
  jwt,
  id,
  onSubmit,
  onCancel,
  onDestroy,
  onChange,
  onView,
  reactSubmissionCallbackError
}) {
  const {
    createClientInstance,
    updateClientInstance
  } = useWhiteLabelDm(jwt);
  const whitelabelmodalEdit = useRef(null);
  const {
    t
  } = useTranslation();
  const {
    item,
    title,
    customTheme: [customTheme]
  } = useWhiteLabelItemGenerator({
    id,
    jwt,
    onChange
  });
  const adminPermissions = useAdminPermissionsItems(item?.admin_permissions);
  const accountPermissions = useAccountPermissionsItems(item?.default_account_permissions, {
    namePrefix: "default_account_permissions"
  });
  const [isWhiteLabelEnabled, setWhiteLabelStatus] = useState({
    white_label_status: item?.white_label_status || false
  });
  const formRef = useRef(null);
  let [skinningItem, setSkinningtem] = useState(customTheme);
  let isFromSkinOption = false;
  let finalSkinningItem;
  const ciRef = useRef({
    white_label_status: false
  });
  ciRef.current = isWhiteLabelEnabled;
  useEffect(() => {
    if (id) {
      setWhiteLabelStatus({
        white_label_status: item?.white_label_status || false
      });
    }
  }, [item]);
  useEffect(() => {
    if (item) {
      setSkinningtem({
        name: item?.white_label?.name,
        white_label: item?.white_label
      });
      finalSkinningItem = {
        name: item?.white_label?.name,
        white_label: item?.white_label
      };
    } else {
      setSkinningtem(customTheme);
    }
  }, [item]);
  const _onCancel = useCallback(() => {
    execFn(onCancel, id);
  }, [id, onCancel]);
  const filterLogos = useCallback((params) => {
    return {
      ...params,
      white_label: {
        ...params.white_label,
        principal_logo: params?.white_label?.principal_logo?.startsWith("filename:") ? "data:" + params?.white_label?.principal_logo?.split(":data:")[1] : params?.white_label?.principal_logo,
        public_logo: params?.white_label?.public_logo?.startsWith("filename:") ? "data:" + params?.white_label?.public_logo?.split(":data:")[1] : params?.white_label?.public_logo,
        favicon_logo: params?.white_label?.favicon_logo?.startsWith("filename:") ? "data:" + params?.white_label?.favicon_logo?.split(":data:")[1] : params?.white_label?.favicon_logo,
        mobile_in_app_logo: params?.white_label?.mobile_in_app_logo?.startsWith("filename:") ? "data:" + params?.white_label?.mobile_in_app_logo?.split(":data:")[1] : params?.white_label?.mobile_in_app_logo,
        mobile_app_skin_logo: params?.white_label?.mobile_app_skin_logo?.startsWith("filename:") ? "data:" + params?.white_label?.mobile_app_skin_logo?.split(":data:")[1] : params?.white_label?.mobile_app_skin_logo
      }
    };
  }, []);
  const compileBase64String = (logostring) => {
    if (logostring) {
      return logostring?.startsWith("filename:") ? "data:" + logostring?.split(":data:")[1] : logostring;
    }
    return logostring;
  };
  const getAllValues = useCallback(() => {
    return {
      ...formRef.current?.getAllValues()
    };
  }, []);
  const _onSubmit = useCallback(() => {
    const contents = getAllValues();
    if (!isFromSkinOption && contents) {
      if (contents?.default_account_permissions?.permission_view_help_section) {
        contents.default_account_permissions.permission_view_help_section = false;
      }
      let data = {
        id: item?.id || 0,
        name: contents.name,
        white_label_status: ciRef.current["white_label_status"],
        white_label: {
          id: item?.white_label?.id || 0,
          name: finalSkinningItem?.name || customTheme.white_label?.name || "White Label",
          primary_color: finalSkinningItem?.white_label.primary_color || customTheme.white_label.primary_color,
          secondary_color: finalSkinningItem?.white_label.secondary_color || customTheme.white_label.secondary_color,
          tertiary_color: finalSkinningItem?.white_label.tertiary_color || customTheme.white_label.tertiary_color,
          success_color: finalSkinningItem?.white_label.success_color || customTheme.white_label.success_color,
          warning_color: finalSkinningItem?.white_label.warning_color || customTheme.white_label.warning_color,
          error_color: finalSkinningItem?.white_label.error_color || customTheme.white_label.error_color,
          aux_color: finalSkinningItem?.white_label.aux_color || customTheme.white_label.aux_color,
          default_email: finalSkinningItem?.white_label.default_email || customTheme.white_label.default_email || "test4@gmail.com",
          api_url: finalSkinningItem?.white_label.api_url || customTheme.white_label.api_url,
          web_url: finalSkinningItem?.white_label.web_url || customTheme.white_label.web_url,
          media_url: finalSkinningItem?.white_label.media_url || customTheme.white_label.media_url,
          company_help_email: finalSkinningItem?.white_label.company_help_email || customTheme.white_label.company_help_email,
          favicon_logo: finalSkinningItem?.white_label.favicon_logo || null,
          principal_logo: finalSkinningItem?.white_label.principal_logo || null,
          public_logo: finalSkinningItem?.white_label.public_logo || null,
          mobile_in_app_logo: finalSkinningItem?.white_label.mobile_in_app_logo || null,
          mobile_app_skin_logo: finalSkinningItem?.white_label.mobile_app_skin_logo || null
        },
        admin_permissions: contents.admin_permissions,
        default_account_permissions: contents.default_account_permissions
      };
      data = filterLogos(data);
      if (!id) {
        createClientInstance(data).then((response) => {
          execFn(onSubmit, response);
        }, function(error) {
          execFn(reactSubmissionCallbackError, error);
        });
      } else {
        updateClientInstance(id, data).then((response) => {
          execFn(onSubmit, response);
        }, function(error) {
          execFn(reactSubmissionCallbackError, error);
        });
      }
    } else {
      isFromSkinOption = false;
    }
  }, [createClientInstance, getAllValues, id, onSubmit, updateClientInstance]);
  const changeEdit = useCallback(() => {
    const values = filterLogos(getAllValues());
    execFn(onChange, values);
  }, [onChange, filterLogos, getAllValues]);
  const closeSkinningModal = useCallback(() => {
    whitelabelmodalEdit.current?.hide();
  }, []);
  const _onSubmitCallbackSkining = useCallback((skinitem, isFromWhiteLabel, whitelabelItem) => {
    isFromSkinOption = isFromWhiteLabel;
    finalSkinningItem = skinitem;
    setSkinningtem(skinitem);
    closeSkinningModal();
  }, []);
  const openModal = useCallback(() => {
    whitelabelmodalEdit.current?.show();
  }, []);
  const editWhiteLabel = useCallback(() => {
    openModal();
  }, [openModal]);
  const setWhiteLabelItem = (skinningItem2) => {
    let tempdata = {
      id: item?.white_label.id || 0,
      name: skinningItem2?.name,
      api_url: skinningItem2?.white_label.api_url,
      aux_color: skinningItem2?.white_label.aux_color,
      company_help_email: skinningItem2?.white_label.company_help_email,
      default_email: skinningItem2?.white_label.default_email,
      error_color: skinningItem2?.white_label.error_color,
      favicon_logo: compileBase64String(skinningItem2?.white_label.favicon_logo),
      media_url: skinningItem2?.white_label.media_url,
      mobile_app_skin_logo: compileBase64String(skinningItem2?.white_label.mobile_app_skin_logo),
      mobile_in_app_logo: compileBase64String(skinningItem2?.white_label.mobile_in_app_logo),
      primary_color: skinningItem2?.white_label.primary_color,
      principal_logo: compileBase64String(skinningItem2?.white_label.principal_logo),
      public_logo: compileBase64String(skinningItem2?.white_label.public_logo),
      secondary_color: skinningItem2?.white_label.secondary_color,
      success_color: skinningItem2?.white_label.success_color,
      tertiary_color: skinningItem2?.white_label.tertiary_color,
      warning_color: skinningItem2?.white_label.warning_color,
      web_url: skinningItem2?.white_label.web_url
    };
    return tempdata;
  };
  return /* @__PURE__ */ React.createElement(WhiteLabelMainContainer, {
    className: cmpClassName("white-label-detail")
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(_StyledTitle, null, title.toUpperCase())), /* @__PURE__ */ React.createElement(WhiteLabelDetailFormContainer, null, /* @__PURE__ */ React.createElement(Form, {
    ref: formRef,
    onCancel: _onCancel,
    onSubmit: _onSubmit,
    validation: "onsubmit",
    isDisabled: onView
  }, /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(Input, {
    name: "name",
    size: "sm",
    label: t("whiteLabel.content.mainForm.name"),
    value: item?.name,
    onChange: changeEdit,
    required: true
  })), /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(_StyledSpan, null, " White Label? "), " ", /* @__PURE__ */ React.createElement(_StyledSpan2, {
    onClick: () => setWhiteLabelStatus({
      white_label_status: !ciRef.current.white_label_status
    })
  }, ciRef.current.white_label_status ? /* @__PURE__ */ React.createElement(SwitchOnIcon, null) : /* @__PURE__ */ React.createElement(SwitchOffIcon, null)), /* @__PURE__ */ React.createElement(_StyledIcon, {
    role: "edit-action",
    color: ciRef.current.white_label_status ? "var(--secondaryColor)" : "var(--tertiaryColor)",
    name: "edit",
    onClick: () => ciRef.current.white_label_status ? editWhiteLabel() : null
  }), /* @__PURE__ */ React.createElement(Modal, {
    ref: whitelabelmodalEdit,
    width: "820px",
    dismiss: true,
    persistent: true,
    modalClassName: "white-label-detail-modal"
  }, /* @__PURE__ */ React.createElement(WhiteLabelSkiningDetailPage, {
    jwt,
    id: item?.id,
    whitelabelItem: setWhiteLabelItem(skinningItem),
    onSubmitSkining: _onSubmitCallbackSkining,
    onCancel: closeSkinningModal,
    onChange: changeEdit,
    isDisabled: onView
  }))), /* @__PURE__ */ React.createElement(FormTitleRowContainer, null, /* @__PURE__ */ React.createElement(SectionTitle, {
    tag: "h3",
    bold: false
  }, t("whiteLabel.content.permissionsSection.title"))), /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(Expander, {
    text: t("whiteLabel.content.adminPermissionsSection.title")
  }, /* @__PURE__ */ React.createElement(CheckboxGroup, {
    items: adminPermissions,
    selectAll: t("whiteLabel.content.adminPermissionsSection.selectAll")
  }))), /* @__PURE__ */ React.createElement(FormRowContainer, {
    className: "default-account-permissions"
  }, /* @__PURE__ */ React.createElement(Expander, {
    text: t("whiteLabel.content.defaultAccountPermissions.title")
  }, /* @__PURE__ */ React.createElement(CheckboxGroup, {
    items: accountPermissions,
    selectAll: t("whiteLabel.content.defaultAccountPermissions.selectAll")
  }))))));
}
export default /* @__PURE__ */ React.memo(withReduxAndStyle(WhiteLabelDetailPage));
var _StyledTitle = _styled(Title).withConfig({
  displayName: "white-label-detailpage___StyledTitle",
  componentId: "sc-z1u8nj-0"
})({
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  width: "100%"
});
var _StyledSpan = _styled("span").withConfig({
  displayName: "white-label-detailpage___StyledSpan",
  componentId: "sc-z1u8nj-1"
})({
  marginTop: "0.25rem"
});
var _StyledSpan2 = _styled("span").withConfig({
  displayName: "white-label-detailpage___StyledSpan2",
  componentId: "sc-z1u8nj-2"
})({
  cursor: "pointer"
});
var _StyledIcon = _styled(Icon).withConfig({
  displayName: "white-label-detailpage___StyledIcon",
  componentId: "sc-z1u8nj-3"
})({
  cursor: "pointer"
});
